import React, { Component } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';

import "./Project.scss";

class Project extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            project: props.location.state.project
        };
    }

    render() {

        let name = this.state.project.name;
        let description = this.state.project.description;
        let overview = this.state.project.overview;
        let features = this.state.project.features;
        let techwrapups = this.state.project.techwrapups;
        let technologies = this.state.project.technologies;
        let github = this.state.project.github;
        let images = this.state.project.images;

        return (
            <section id="project">
                <Container fluid className="title-section">
                    <Row>
                        <h1 className="title">{name}</h1>
                    </Row>
                    <Row>
                        <h5 className="subtitle">{description}</h5>
                    </Row>
                </Container>
                <Container fluid className="content">
                    <Row className="project-content">
                        <Col md={6}>
                            <Row className="project-overview">
                                <h5 className="title">Overview</h5>
                                <p className="overview">{overview}</p>
                            </Row>
                            <Row className="project-features">
                                <h5 className="title">Features</h5>
                                <ul>
                                    {features.map((feature, index) => {
                                        return <li key={index}>
                                            <span className="feature-title">{feature.title}</span>{` - ${feature.description}`}
                                        </li>
                                    })}
                                </ul>
                            </Row>
                            <Row className="project-view">
                                <Link to={`/projects/${name.replace(/\s+/g, '-').toLowerCase()}/demo`} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faExternalLinkAlt} /> <span>View Demo</span>
                                </Link>
                                <a href={github} target="_blank">
                                    <FontAwesomeIcon icon={faGithub} /> <span>View Source</span>
                                </a>
                            </Row>
                        </Col>
                        <Col md={6} className="left-border">
                            <Row className="project-techwrapup">
                                <h5 className="title">Tech Wrap-Up</h5>
                                {techwrapups.map((techwrapup, index) => {
                                    return <div key={index}>
                                        <h5 className="techwrapup-title">{techwrapup.title}</h5>
                                        <ul>
                                            {techwrapup.bulletpoints.map((bulletpoint, index) => {
                                                return <li key={index}>{bulletpoint}</li>
                                            })}
                                        </ul>
                                    </div>
                                })}
                            </Row>
                            <Row className="project-technologies">
                                <h6 className="title">Technologies Used</h6>
                                <Row>
                                    {technologies.map((technology, index) => {
                                        return <a key={index} href={technology.link} target="_blank">
                                            {technology.title}
                                        </a>
                                    })}
                                </Row>
                            </Row>
                        </Col>
                    </Row>
                    <Col className="project-images">
                        {images.map((image, index) => {
                            return <Image key={index} src={`/images/${image}`} rounded />
                        })}
                    </Col>
                </Container>
            </section>
        );
    }
};

export default Project;